import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { EntrepreneurProspectCourse, LanguageId } from '@interfaces';
import { DomainDataService } from '../../../../../../services';


export function getColumns(util: UtilityService, domainData: DomainDataService) {

	const columns: GridColumn<EntrepreneurProspectCourse, unknown>[] = [
		buildColumn(util, 'Id', row => row.courseEnrollmentId),
		buildColumn(util, 'Text', row => LanguageId.English == row.languageId ? 'English' : 'Spanish', { header: 'Language', 'width': 60 }),
		buildColumn(util, 'Text', row => row.typeName, { header: 'Course Type' }),
		buildColumn(util, 'Text', row => row.courseName, { header: 'Course Name' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.createdUTC), { header: 'Enrolled On', 'width': 60 }),
		buildColumn(util, 'Date', row => row.createdUTC !== row.updatedUTC ? util.date.fromUTC(row.updatedUTC) : undefined, { header: 'Last Activity', 'width': 60 }),
		buildColumn(util, 'Percent', row => row.completionPercentage, { header: 'Completion', 'width': 50 }),
	];


	return columns;

}